
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class GradientInput extends Vue {
  @Prop({ default: "" })
  value!: string | number;

  @Prop({ default: "" })
  label!: string;

  @Prop({ default: "text" })
  type!: string;

  @Prop({ default: "" })
  classes!: string;

  @Prop({ default: () => {} })
  onFocus!: Function;

  @Prop({ default: () => {} })
  onBlur!: Function;
}
